<template>
    <div class="map-container">
        <div
            id="map"
            class="map"
        />
    </div>
</template>

<script>
    import Icon from '@/components/icon';
    import gmaps from '@/plugins/gmaps';

    let google;
    let map;

    export default {
        name: 'simple-map',
        components: {
            Icon,
        },
        data() {
            return {
                markers: [],
                imgUrl: '/app/themes/rugby/dist/images/',
            };
        },
        props: {
            latLng: {
                required: true,
                type: Object,
            },
        },
        async mounted() {
            try {
                google = await gmaps.init(this.key);
                this.bounds = new google.maps.LatLngBounds();

                map = new google.maps.Map(document.getElementById('map'), {
                    zoom: 1,
                    disableDefaultUI: true,
                    zoomControl: true,
                });

                const geocoder = new google.maps.Geocoder();
                geocoder.geocode({ address: 'Midden nederland' }, (results, status) => {
                    if (status !== 'OK' || !results[0]) throw new Error(status);
                    map.setCenter(this.bounds.getCenter());
                    map.fitBounds(this.bounds);
                    map.setZoom(map.getZoom() - 8);
                });

                this.addMarker();
            } catch (error) {
                console.error(error);
            }
        },
        methods: {
            addMarker() {
                const marker = new google.maps.Marker({
                    map,
                    title: 'club',
                    icon: `${this.imgUrl}pin.png`,
                    position: {
                        lat: parseFloat(this.latLng.lat),
                        lng: parseFloat(this.latLng.lng),
                    },
                });
                this.markers.push(marker);
                this.bounds.extend(marker.getPosition());
            },
        },
    };
</script>

<style lang="scss">
    .map-container {
        position: relative;
        min-height: 260px;
        overflow: hidden;
        background-color: $gray;
    }
</style>

<style lang="scss" scoped>
    .map {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>
